import { SxProps, Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { assessmentTabletLandscapeMedia } from "../assessment-layout-styles";

export const rootStyle: SxProps<Theme> = {
  position: "relative",
};

export const dimmedContentStyle: SxProps<Theme> = {
  pointerEvents: "none",
  opacity: 0.55,
};

const compactPanelLayout = (theme: Theme) => ({
  position: "fixed" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(100% - 32px)",
  maxWidth: 360,
  zIndex: theme.zIndex.modal + 1,
  py: 2.5,
  boxShadow: theme.shadows[6],
});

export const panelStyle = (
  theme: Theme,
  isCompactLayout: boolean,
): SxProps<Theme> => {
  const compactPanel = compactPanelLayout(theme);

  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "12px",
    backgroundColor: alpha(theme.palette.quizPopap.quizSelector, 0.98),
    px: 2,
    ...(isCompactLayout
      ? compactPanel
      : {
          position: "absolute",
          inset: 0,
          zIndex: 2,
        }),
    [assessmentTabletLandscapeMedia]: compactPanel,
  };
};

export const progressStyle: SxProps<Theme> = {
  color: "#06B6D4",
  mb: 1.5,
};

export const titleStyle = (theme: Theme): SxProps<Theme> => ({
  color: theme.palette.quizPopap.quizSelectorText,
  fontSize: "14px",
  textAlign: "center",
  fontWeight: 600,
});

export const subtitleStyle = (theme: Theme): SxProps<Theme> => ({
  color: theme.palette.quizPopap.quizSelectorText,
  fontSize: "12px",
  textAlign: "center",
  mt: 0.5,
  opacity: 0.7,
});
